import { render, staticRenderFns } from "./ListItemId.vue?vue&type=template&id=6e88c208"
import script from "./ListItemId.vue?vue&type=script&lang=js"
export * from "./ListItemId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports